import { AuthorList } from '..';
import { WEB_SCHEMA } from '../../../constants/componentStaticData';
import { Meta } from '../../../layout/Meta';
import { AuthorLayout } from '../AuthorLayout';
import { SEO_DETAILS } from '../constants';
import { IGET_AUTHOR_LAYOUT, IPAGINATED_AUTHORS_LIST } from '../types';

export const AuthorListPage = ({ data }: IGET_AUTHOR_LAYOUT) => {
  return (
    <AuthorLayout>
      <Meta
        title={SEO_DETAILS.title}
        description={SEO_DETAILS.metaDesc}
        canonical={SEO_DETAILS.url}
        key="robots"
      />
      <AuthorList data={data as IPAGINATED_AUTHORS_LIST} />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(
            WEB_SCHEMA({
              ...SEO_DETAILS,
            })
          ),
        }}
      ></script>
    </AuthorLayout>
  );
};
